import { Campaign, CampaignCreateParams } from '../../../types'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Alert } from '../../../ui'
import Heading from '../../../ui/Heading'
import { CampaignListSelection } from './CampaignListSelection'

interface AudienceStepProps {
    form: UseFormReturn<CampaignCreateParams>
    campaign?: Campaign
}

export default function CampaignAudienceStep({ form, campaign }: AudienceStepProps) {
    const { t } = useTranslation()
    const campaignType = useWatch({
        control: form.control,
        name: 'type',
    })

    if (campaignType === 'trigger') {
        return (
            <>
                <Heading size="h3" title={t('wizard_audience_title')}>
                    {t('wizard_audience_desc')}
                </Heading>
                <Alert variant="plain" title={t('wizard_audience_trigger_title')}>
                    {t('wizard_audience_trigger_desc')}
                </Alert>
            </>
        )
    }

    return (
        <>
            <Heading size="h3" title={t('wizard_audience_title')}>
                {t('wizard_audience_desc')}
            </Heading>
            <CampaignListSelection
                title={t('wizard_audience_send_lists')}
                subtitle={t('wizard_audience_send_lists_desc')}
                name="list_ids"
                value={campaign?.lists}
                control={form.control}
                required={true}
            />
            <CampaignListSelection
                title={t('exclusion_lists')}
                subtitle={t('wizard_audience_exclusion_lists_desc')}
                name="exclusion_list_ids"
                value={campaign?.exclusion_lists}
                control={form.control}
                required={false}
            />
        </>
    )
}
